import { DebugModel } from '~/features/x-ray/debug';

const Page = () => {
  return <DebugModel />;
};

export default Page;
